const image = (param) => {
    let caption = "";
    if (param.caption){
        caption = '<div class="block-image__description">'+ param.caption +'</div>';
    }
    return `
            <div class="block-image">
                <img src='${param.file.url}' alt='${param.caption}' loading="lazy"/>
                ${caption}
            </div>`
}
module.exports = image
